import { notify } from '@yembo/yemblocks-core';
import { LoginSuccessResponseWithDevice } from 'src/queries/Login';
import { getStatuses, MFA_LOCKOUT } from 'src/queries/apiStatus';
import { YemboApiError } from 'src/queries/queryYemboApiCalls';
import { updateAuth } from 'src/util/AuthModule';
import { clearPendingLogin } from './pendingLogin';

const LOCKED_ACCOUNT_ERROR_MESSAGE =
  'This account has been locked for security reasons. Please contact support to restore access.';

export function loginDevice(deviceResponse: LoginSuccessResponseWithDevice) {
  const { accessToken, userKey, key } = deviceResponse.device;
  clearPendingLogin();
  updateAuth({
    accessToken,
    employeeKey: userKey,
    deviceKey: key,
    impersonatedCompanyKeys: null,
    impersonatedRole: null,
  });
}

/** A locked account answers every sign-in step with 401 `mfa_lockout` (routes/Employee.ts). */
export function notifyLockedAccount(error: unknown) {
  if (!(error instanceof YemboApiError)) return false;

  const lockedStatus = getStatuses(error.errorJson).find(({ type }) => type === MFA_LOCKOUT);
  if (!lockedStatus) return false;

  notify.error(lockedStatus.message ?? LOCKED_ACCOUNT_ERROR_MESSAGE);
  return true;
}
